import { api } from '../api'

export const bugReportApi = api
  .enhanceEndpoints({
    addTagTypes: ['BugReport'],
  })
  .injectEndpoints({
    endpoints: (builder) => ({
      addBugReport: builder.mutation({
        query: ({ params }) => ({
          url: '/bug-report/send',
          method: 'POST',
          body: params,
        }),
        invalidatesTags: ['BugReport'],
      }),
    }),
  })

export const { useAddBugReportMutation } = bugReportApi
